import React, { Fragment } from 'react'

import Wizard from '@modules/form-wizard'
import SERVICE_PROPS from '@helpers/extract-service-props'
import moment from 'moment'
import toastr from '@modules/toastr'
import Swal from 'sweetalert2'
import { ValidatorForm } from 'react-form-validator-core'
import Modal from 'react-responsive-modal'
import Loader from '@shared/loader'
import DateTimeField from '@shared/form-fields/date'
import { fullName } from '@modules/form-wizard/utils'

export default class BuildingInspectionRequest extends React.Component {
  resource = '/building_inspection_requests'
  form_key = 'building_inspection_request'
  defaults = {}
  state = { record: null, loading: false, date: new Date() }

  // Delete lines as needed
  fee = 99
  free = true
  postpaid = true
  skip_location = true
  hide_buttons  = {
    status: true,
    deny: false,
    approve: true,
  }
  custom_actions = [
    {
      text: 'Confirm Appointment Date',
      icon: 'chevron-right',
      roles: [['inspector']],
      test: r => ['pending', 'processing'].includes(r.application_decision),
      fn: async record => this.setState({ record })
    },

    {
      text: 'Approve',
      icon: 'chevron-right',
      roles: [['officer', 'inspector']],
      test: r => ['awaiting inspection'].includes(r.application_decision),
      fn: async record => this.approve_inspector(record)
    },

    {
      text: 'Assign Inspector',
      icon: 'bullhorn',
      roles: ['officer'],
      test: r => r.application_decision == 'pending' || r.application_decision == 'processing',
      fn: async record => this.approve_clerk(record, 'Forward to Inspector'),
    },
  ]

  validate = null

  foremost = null

  /*
  t.string :building_permit_numb
  t.string :building_address
  t.string :portion_desc
  t.date :inspection_date
  t.string :contractor_first_name
  t.string :contractor_last_name
  t.string :contractor_address
  t.string :contractor_phone
  t.date :contracted_date
  t.string :electrical_spec_numb
  t.string :owner_first_name
  t.string :owner_last_name

  t.attachment :identification_upload
  */

  fields = form => [
    {
      name: 'confirmed_appointment_date',
      label: 'Confirmed Appointment Date',
      type: 'date',
      hide: true,
      view: {
        element: (value, form) => form.confirmed_appointment_date ? (
            <Fragment>
              <h5 className='sub'>Confirmed Appointment Date</h5>
              <p>{moment(value).format('MMMM DD, YYYY hh:mm A')}</p>
            </Fragment>
          ) : (
            <Fragment>
              <h5 className='sub'>Confirmed Appointment Date</h5>
              <p>N/A</p>
            </Fragment>
          )
      }
    },
    {
      name: 'approved_date',
      type: 'date',
      hide: true,
    },
    {
      name: 'building_permit_numb',
      label: ' Building Permit number',
    },
    {
      name: 'building_address',
      label: 'Address of Building',
    },
    {
      name: 'portion_desc_list',
      label: 'Description of Portion or Portions requiring Inspection',
      // type: 'textarea',
      options: [
        'Foundation',
        'Filing',
        'Column',
        'Structural Column',
        'Tie-Beam',
        'Structural Beam and Slab',
        'Structural Framework',
        'Roof',
        'Plumbing',
        'Special',
        'Electrical',
        // 'Other',
      ],
      multi: true,
    },
    // {
    //   name: 'inspection_date',
    //   label: 'Date ready for inspection',
    //   type: 'date',
    // },

    '::Owner Details',
    {
      name: 'i_am_owner',
      label: 'I am the owner',
      type: 'select:bool',
    },
    {
      name: 'i_am',
      label: 'I am the...',
      options: [
        { name: 'contractor', label: 'Builder/Contractor'},
        { name: 'electrician', label: 'Electrician/Contractor'},
        { name: 'plumber', label: 'Plumber/Contractor'},
      ],
      hide: form.i_am_owner,
    },
    {
      name: 'owner_first_name',
      label: 'First name',
      hide: form.i_am_owner,
    },
    {
      name: 'owner_last_name',
      label: 'Last name',
      hide: form.i_am_owner,
    },

    '::Contractor Details',
    {
      name: 'contractor_first_name',
      label: 'First name',
      hide: !form.i_am_owner,
    },
    {
      name: 'contractor_last_name',
      label: 'Last name',
      hide: !form.i_am_owner,
    },
    {
      name: 'contractor_address',
      label: 'Address',
    },
    {
      name: 'contractor_phone',
      label: 'Telephone number',
      type: 'phone',
    },
    // {
    //   name: 'contracted_date',
    //   label: 'Contracted Date',
    //   type: 'date',
    // },
    {
      name: 'electrical_spec_numb',
      label: 'Electrical Specification Number',
      // type: 'integer',
      required: false,
    },
    {
      name: 'plumbing_spec_numb',
      label: 'Plumbing Specification Number',
      // type: 'integer',
      required: false,
    },

    "::Uploads",
    {
      name: 'identification_upload',
      label: 'Government issued ID',
      key: 'image.0',
      type: 'file:all',
      required: false,
    },
    {
      name: 'water_sewage_letter_upload',
      label: 'Water Sewage Letter',
      hint: 'Letters must have offical stampage',
      key: 'image.1',
      type: 'file:all',
      required: false,
    },
    // {
    //   name: 'occupancy_process_card_upload',
    //   label: 'Occupancy Process Card (Front)',
    //   hint: 'Card must be stamped by DEHS',
    //   key: 'image.2',
    //   type: 'file:all',
    //   required: false,
    // },
    // {
    //   name: 'occupancy_process_card_two_upload',
    //   label: 'Occupancy Process Card (Back)',
    //   hint: 'Card must be stamped by DEHS',
    //   key: 'image.3',
    //   type: 'file:all',
    //   required: false,
    // },
  ]


  // Custom Action Functions
  setAppt = async () => {
    const { props, state, resource, form_key } = this
    const { history, location } = props
    const { date, record } = state

    this.setState({ loading: true })

    try {
      await $app.axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: 'approved',
          confirmed_appointment_date: new Date(date),
        },
      })

      if (location?.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'approved'

        history.replace(location.pathname, {
          ...location.state,
          view,
        })
      }

      toastr.success('Success', 'Application successfully updated')
    } catch (error) {
      console.error(error)
      Swal.fire(
        'Oops...',
        'There has been an error with processing your application',
        'error'
      )
    } finally {
      this.setState({ record: null, loading: false })
    }
  }

  async approve_inpsector(record) {
    let inputOpts = {
      'approve': "Approve Application",
    }

    let value = null

    const firstStep = await Swal.fire({
      icon: 'question',
      title: 'Approve Application',
      html: `
        Approve application after thorough inspection, 
        <strong>${fullName(record.user, 'initial')}</strong>, for
        <br/>${moment(this.state.record?.appointment_date).format('MMMM DD, YYYY hh:mm A')}?
      `,
      input: 'select',
      inputOptions: inputOpts,
      showCancelButton: true,
      confirmButtonText: 'Approve',
    })

    if (firstStep.isDismissed) return
    value = firstStep.value
  
    this.setState({ loading: true })
  
    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app
  
    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
        },
      })
  
      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'approved'
  
        history.replace(location.pathname, { ...location.state, view })
      }
  
      toastr.success('Success', 'Application successfully updated')
    } catch (error) {
      console.error(error)
      toastr.error('Error', 'Unable to update application')
      return
    }
  
    this.setState({ loading: false })
  }

  async approve_clerk(record, mTitle, mText = 'Proceed to the next stage regarding') {
    let inputOpts = {
      'approved': "I recommend this applicant",
      'denied': "I do not recommend this applicant",
    }
    const inspectorList = {};
    if (mTitle === 'Forward to Inspector') {
      const { data } = await $app.axios.get('/building_inspection_requests/show_inspectors')
      const inspectorMap = data.records.map(x => {
        return { id: x.id, name: `${x.first_name} ${x.last_name}` }
      })
      this.setState({ all_inspectors: inspectorMap })
      this.state.all_inspectors.forEach(e => {
        inspectorList[`${e.id}`] = e.name;
      })
      // console.log(inspectorList);
      inputOpts = {
        'approved': "Approve this applicant",
        // 'return': "Application needs to be reprocessed",
        'denied': "Application needs to be reprocessed",
      }
    }

    let value = null
    let officerID = null

    if (mTitle === 'Forward to Inspector') {
      const firstStep = await Swal.fire({
        icon: 'question',
        title: mTitle,
        html: `
          ${mText} the applicant,
          <strong>${fullName(record.user, 'initial')}</strong>?
        `,
        input: 'select',
        inputOptions: inputOpts,
        showCancelButton: true,
        confirmButtonText: 'Send',
      })

      if (firstStep.isDismissed) return
      value = firstStep.value

      if (value === 'approved') {
        const lastStep = await Swal.fire({
          icon: 'question',
          title: mTitle,
          html: `
            Select which inspector you would wish to assign to this application.
          `,
          input: 'select',
          inputOptions: inspectorList,
          showCancelButton: true,
          confirmButtonText: 'Send',
        })
  
        if (lastStep.isDismissed) return
        officerID = lastStep.value
        // console.log(officerID)
      }

    }
    this.setState({ loading: true })
  
    const { props, resource, form_key } = this
    const { history, location } = props
    const { axios } = $app
  
    try {
      await axios.put(resource + '/update_application', {
        [form_key]: {
          form_num: record.form_num,
          application_decision: value,
          inspector_id: officerID,
        },
      })
  
      if (location.state?.view) {
        const view = { ...location.state.view }
        view.application_decision = 'officer viewed'
  
        history.replace(location.pathname, { ...location.state, view })
      }
  
      toastr.success('Success', 'Application successfully updated')
    } catch (error) {
      console.error(error)
      toastr.error('Error', 'Unable to update application')
      return
    }
  
    this.setState({ loading: false })
  }

  closeModal = () => this.setState({ record: null })
  onChange = date => this.setState({ date })

  render = () => (
    <Fragment>
      <Loader loading={this.state.loading} />
      <Wizard {...SERVICE_PROPS(this)} />
      <Modal
        open={!!this.state.record && !this.state.loading}
        onClose={this.closeModal}
        classNames={{ modal: 'w-full sm:w-128' }}
        center
      >
        <header className='modal-header'>
          <h4 className='mb-0'>Confirm Appointment Date</h4>
        </header>
        <ValidatorForm onSubmit={this.setAppt}>
          <article className='modal-body'>
            <label htmlFor='selected_date' className='form-label'>
              Current selected date
            </label>
            <div name='selected_date' className='font-bold'>{moment(this.state.record?.confirmed_appointment_date).format('MMMM DD, YYYY hh:mm A')}</div>
          </article>
          <article className='modal-body'>
            <label htmlFor='date' className='form-label'>
              Please set the applicant's appointment date
            </label>
            <DateTimeField
              name='date'
              dateFormat="MMMM d, yyyy h:mm aa"
              timeInputLabel="Time:"
              showTimeInput
              icon={null}
              minDate={new Date()}
              selected={this.state.date}
              value={new Date(this.state.record?.confirmed_appointment_date)}
              onChange={this.onChange}
              validators={['required']}
              errorMessages={['Please enter a valid date']}
              className='form-control'
              required
            />
          </article>
          <footer className='modal-footer'>
            <button type='button' className='btn' onClick={this.closeModal}>
              Cancel
            </button>
            <button type='submit' className='btn btn-primary'>
              Submit
            </button>
          </footer>
        </ValidatorForm>
      </Modal>
    </Fragment>
  )
}
